import { z } from 'zod'
import {
  Auftrag1_10ZeileSchema,
  DEFAULT_AUFTRAG1_10_ZEILE
} from './auftrag1_10-zeile-form.schema'
import { AuftragX_25Schema, AuftragX_95Schema } from '../../Auftraege'

// Default constants
const DEFAULT_AUFTRAG_1_10 = {
  enabled: true,
  zeilen: [DEFAULT_AUFTRAG1_10_ZEILE]
}

const DEFAULT_BEFEHL_1_FORM = {
  auftrag_1_10: DEFAULT_AUFTRAG_1_10,
  auftrag_1_25: {
    enabled: false
  },
  auftrag_1_95: {
    enabled: false,
    freitext: ''
  }
}

// Schema definitions
const Auftrag1_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG_1_10.enabled),
    zeilen: z
      .array(Auftrag1_10ZeileSchema)
      .min(1)
      .max(3)
      .default(DEFAULT_AUFTRAG_1_10.zeilen)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG_1_10))

// Base schema
const Befehl1FormSchemaBase = z
  .object({
    auftrag_1_10: Auftrag1_10Schema,
    auftrag_1_25: AuftragX_25Schema,
    auftrag_1_95: AuftragX_95Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_1_FORM))

export const Befehl1FormSchema = Befehl1FormSchemaBase

// Validation schema factory
export const createBefehl1FormValidationSchema = () => {
  return Befehl1FormSchemaBase
}

export type Befehl1FormData = z.infer<typeof Befehl1FormSchemaBase>
